import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getStreamChannels } from '../../../api/channels';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateStreamCIDKey } from '../../../components/Streams/utils/generateStreamCIDKey';
import { normalizeChannelHovercardList } from '../../../components/Channels/utils/normalizeChannelHovercardList';

export const fetchStreamChannels = createAsyncThunk(
  `channels/fetchStreamChannels`,
  async ({ path }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getStreamChannels(
        { path, params: { full: true } },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const fetchStreamChannelsExtraReducers = builder => {
  builder
    .addCase(fetchStreamChannels.pending, (state, action) => {
      checkAndSetLoadingWithId(
        state.channels.stream.request,
        action,
        generateStreamCIDKey(action.meta.arg.path),
      );
    })
    .addCase(fetchStreamChannels.fulfilled, (state, action) => {
      const streamCIDKey = generateStreamCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.channels.stream.request[streamCIDKey],
        action,
        () => {
          const { byId, allIds } = normalizeChannelHovercardList(
            action.payload,
          );

          state.channels.stream.byStream = {
            ...state.channels.stream.byStream,
            [streamCIDKey]: allIds,
          };

          const resultById = {
            ...state.channels.hoveredChannels.byId,
            ...byId,
          };

          state.channels.hoveredChannels.byId = resultById;
          state.channels.hoveredChannels.allIds = Object.keys(resultById);
        },
      );
    })
    .addCase(fetchStreamChannels.rejected, (state, action) => {
      handleRequestRejection(
        state.channels.stream.request[
          generateStreamCIDKey(action.meta.arg.path)
        ],
        action,
      );
    });
};
